import React, {ReactNode} from "react";
import { createRoot } from "react-dom/client";


export const ClientEntry = async(entry: ReactNode) => {
    if (!document)
        return;

    const el = document.getElementById("root");
    if (el) {
        const root = createRoot(el);
        root.render(
            <React.StrictMode>
                {entry}
            </React.StrictMode>
        );
    } else {
        throw new Error("Could not find root element");
    }

}